import { Box, Typography } from "@mui/material";
import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import QuestionAnswerComponent from "./QuestionAnswerComponent";
import { AntwoordTekst } from "./components/AntwoordTekst";
import { soortVan } from "../../lib/enquete";

const FeedbackDetails = ({ Css }) => {
  const { feedBackDetails, basicLanguages } = useSelector((s) => s.feedback);

  const enqueteList = useMemo(
    () => feedBackDetails?.enqueteList || [],
    [feedBackDetails?.enqueteList]
  );

  const isEmpty = enqueteList.length === 0;

  return (
    <Box sx={{ px: { xs: 2, md: 4 }, pt: { xs: 3, md: 4 }, pb: 2 }}>
      {/* ── Section header ── */}
      <Box sx={{ mb: 4 }}>
        <Typography
          sx={{
            color: Css?.feedbackHeadingClr || "#111827",
            fontSize: { xs: "22px", md: "26px" },
            fontWeight: 700,
            letterSpacing: "-0.02em",
            lineHeight: 1.2,
            mb: 1,
          }}
        >
          {basicLanguages?.HeaderSurvey}
        </Typography>
        <Typography
          sx={{
            color: Css?.feedbackInfoClr || "#6b7280",
            fontSize: { xs: "13px", md: "14px" },
            lineHeight: 1.7,
            maxWidth: 560,
          }}
        >
          {basicLanguages?.["lerem ipsum"]}
        </Typography>
      </Box>

      {/* ── Empty state ── */}
      {isEmpty ? (
        <Box
          sx={{
            py: 6,
            textAlign: "center",
            color: Css?.feedbackInfoClr || "#9ca3af",
            fontSize: "14px",
          }}
        >
        {basicLanguages?.noSurveyFounnd ?? " No survey sections found."} 
        </Box>
      ) : (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
          {enqueteList.map((item, index) => (
            <Box
              key={item?.idenquetefield ?? index}
              sx={{
                display: "grid",
                // Sterren met een toelichting ernaast; 0-10 en open tekst over de hele breedte (14-10-2026).
                gridTemplateColumns: { xs: "1fr", md: soortVan(item?.type) === "sterren" ? "1fr 1fr" : "1fr" },
                alignItems: "stretch",
                gap: 2,
                animation: `fadeIn 0.3s ease ${index * 0.07}s both`,
                "@keyframes fadeIn": {
                  from: { opacity: 0, transform: "translateY(8px)" },
                  to: { opacity: 1, transform: "translateY(0)" },
                },
              }}
            >
              <QuestionAnswerComponent data={item} Css={Css} />

              {soortVan(item?.type) === "sterren" && (
                <AntwoordTekst vraag={item} placeholder={basicLanguages?.Typehere} Css={Css} />
              )}
            </Box>
          ))}
        </Box>
      )}
    </Box>
  );
};

export default FeedbackDetails;
